import React, { useCallback } from "react";
// @ts-ignore
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../styles/theme";
// import { useListStyles } from "../components/";
import { withVersionParams } from "../HOC/withVersionParams";
import clsx from "clsx";
import { useListStyles } from "../components/Common/List";

const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
   },
   text: {
      fontSize: "1.8rem",
      padding: "23px 0px",
   },
   info: {
      fontSize: "1.4rem",
      fontWeight: theme.demiLight,
      padding: "23px 20px",
      lineHeight: "2.4rem",
      position: "fixed",
      bottom: 0,
   },
   bold: {
      fontWeight: theme.medium,
      marginBottom: 12,
   },
}));

const TosPage: React.FC = () => {
   const classes = useStyles();
   const listClasses = useListStyles({});
   const navigate = useNavigate();

   const goToDetailPage = useCallback(
      (i: number) => {
         navigate(`/tos/${i}`);
      },
      [navigate]
   );

   return (
      <>
         <HelmetProvider>
            <Helmet>
               <title>이용약관</title>
            </Helmet>
         </HelmetProvider>
         <div className={classes.wrap}>
            <ul className={listClasses.list}>
               <li
                  onClick={() => goToDetailPage(0)}
                  className={listClasses.item}
               >
                  <div
                     className={clsx(listClasses.banner, classes.text, "right")}
                  >
                     서비스 이용약관
                  </div>
               </li>
               {/* <li
                  onClick={() => goToDetailPage(1)}
                  className={listClasses.item}
               >
                  <div
                     className={clsx(listClasses.banner, classes.text, "right")}
                  >
                     증명서 이용약관
                  </div>
               </li> */}
               <li
                  onClick={() => goToDetailPage(3)}
                  className={listClasses.item}
               >
                  <div
                     className={clsx(listClasses.banner, classes.text, "right")}
                  >
                     개인정보 처리방침
                  </div>
               </li>
            </ul>
            <div className={classes.info}>
               <p className={classes.bold}>주식회사 파라메타</p>
               <p>
                  대표 김종협
                  <br />
                  서울특별시 서초구 강남대로 311 드림플러스 8F
                  <br />
                  사업자 등록번호 647-81-00375
                  <br />
                  대표전화 02-2138-7026
               </p>
            </div>
         </div>
      </>
   );
};

export default TosPage;
